import { useEffect, useState } from "react";

import { useBreakpointValue } from "@chakra-ui/react";

type MenuProps = {
  onClose: (boolean) => void;
  isOpen: boolean;
  selectedCategory: string;
  OnCloseDrawer: () => void;
};

export function DrawerCategory({ isOpen, onClose, selectedCategory, OnCloseDrawer }: MenuProps) {
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [carModel, setCarModel] = useState([]);

  const [accordinSelected, setAccordionSelected] = useState(null);
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  function handleMenu() {
    onClose(false);
  }

  useEffect(() => {
    switch (selectedCategory) {
      case "rim":
        setAccordionSelected(0);
        break;
      case "models":
        setAccordionSelected(1);
        break;
      case "categories":
        setAccordionSelected(2);
        break;
      case "vehicles":
        setAccordionSelected(3);
        break;
    }
  }, [selectedCategory]);

  return (
    <></>
    // <Drawer isOpen={isOpen} placement="left" onClose={handleMenu}>
    //   <DrawerOverlay />
    //   <DrawerContent fontFamily="textSpacedSideMenu">
    //     <Flex onClick={handleMenu} alignItems="center">
    //       <Button borderRadius="0">
    //         <IoIosArrowBack />
    //       </Button>
    //       <Text margin="auto 15px" fontWeight="200" color="gray.700">
    //         Voltar
    //       </Text>
    //     </Flex>

    //     <DrawerBody textStyle="textS">
    //       <Text marginTop="30px">PNEUS</Text>

    //       <Accordion
    //         allowToggle
    //         marginTop="24px"
    //         fontSize="text3"
    //         defaultIndex={[accordinSelected]}
    //       >
    //         <AccordionItem borderTopStyle="none">
    //           <AccordionButton>
    //             <Box
    //               flex="1"
    //               alignItems="left"
    //               textStyle="Regular"
    //               color="blue.900"
    //               letterSpacing="0.50rem"
    //               _focus={{ boxShadow: 'none' }}
    //             >
    //               AROS
    //             </Box>
    //             <AccordionIcon />
    //           </AccordionButton>

    //           <AccordionPanel pb={4}>
    //             <Stack spacing="12px" textStyle="Bold" fontSize="text1">
    //               {mockItens.rimSizes.map((item, index) => (
    //                 <Link key={index} href={item.searchUrl}  //passHref
    //         >
    //                   {item.rim}
    //                 </Link>
    //               ))}
    //             </Stack>
    //           </AccordionPanel>
    //         </AccordionItem>

    //         <AccordionItem>
    //           <h2>
    //             <AccordionButton _focus={{ boxShadow: 'none' }}>
    //               <Box
    //                 flex="1"
    //                 alignItems="left"
    //                 textStyle="Regular"
    //                 color="blue.900"
    //                 letterSpacing="0.50rem"
    //               >
    //                 MODELOS
    //               </Box>
    //               <AccordionIcon />
    //             </AccordionButton>
    //           </h2>
    //           <AccordionPanel pb={4}>
    //             <Stack spacing="12px" textStyle="Bold" fontSize="text1">
    //               {mockItens.models.map((item, index) => (
    //                 <Link key={index} href={item.searchUrl}  //passHref
    //         >
    //                   {item.model}
    //                 </Link>
    //               ))}
    //             </Stack>
    //           </AccordionPanel>
    //         </AccordionItem>
    //         {/* <AccordionItem>
    //           <Text as="h2">
    //             <AccordionButton>
    //               <Box
    //                 flex="1"
    //                 alignItems="left"
    //                 textStyle="Regular"
    //                 color="blue.900"
    //                 letterSpacing="0.50rem"
    //               >
    //                 CATEGORIAS
    //               </Box>
    //               <AccordionIcon />
    //             </AccordionButton>
    //           </Text>
    //           <AccordionPanel pb={4} textStyle="Bold" fontSize="text1">
    //             <Stack spacing="12px">
    //               {mockItens.category.map((item, index) => (
    //                 <Link key={index}>{item}</Link>
    //               ))}
    //             </Stack>
    //           </AccordionPanel>
    //         </AccordionItem> */}
    //         <AccordionItem>
    //           <AccordionButton>
    //             <Box
    //               flex="1"
    //               alignItems="left"
    //               textStyle="Regular"
    //               color="blue.900"
    //               letterSpacing="0.50rem"
    //             >
    //               VEÍCULOS
    //             </Box>
    //             <AccordionIcon />
    //           </AccordionButton>

    //           <AccordionPanel pb={4} padding="8px ">
    //             <VehicleSearchMenu
    //               handleMenu={handleMenu}
    //               OnCloseDrawer={OnCloseDrawer}
    //               visible={isWideVersion && true}
    //             />
    //           </AccordionPanel>
    //         </AccordionItem>
    //       </Accordion>
    //     </DrawerBody>
    //   </DrawerContent>
    // </Drawer>
  );
}
//TODO criação categorias do menu, posteriormente conta para junção dos drawers.
